var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_773_2361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5H6.66667C6.88768 2.5 7.09964 2.5878 7.25592 2.74408C7.4122 2.90036 7.5 3.11232 7.5 3.33333V6.66667C7.5 6.88768 7.4122 7.09964 7.25592 7.25592C7.09964 7.4122 6.88768 7.5 6.66667 7.5H3.33333C3.11232 7.5 2.90036 7.4122 2.74408 7.25592C2.5878 7.09964 2.5 6.88768 2.5 6.66667V3.33333Z",
    stroke: "#5A638C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.3333C12.5 13.1123 12.5878 12.9004 12.7441 12.7441C12.9004 12.5878 13.1123 12.5 13.3333 12.5H16.6667C16.8877 12.5 17.0996 12.5878 17.2559 12.7441C17.4122 12.9004 17.5 13.1123 17.5 13.3333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H13.3333C13.1123 17.5 12.9004 17.4122 12.7441 17.2559C12.5878 17.0996 12.5 16.8877 12.5 16.6667V13.3333Z",
    stroke: "#5A638C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 9.16667V6.66667C17.5002 6.22464 17.3246 5.80072 17.012 5.48816C16.6994 5.17559 16.2755 5 15.8335 5H10.8335M10.8335 5L13.3335 7.5M10.8335 5L13.3335 2.5",
    stroke: "#5A638C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.834V13.334C2.5 13.776 2.67559 14.1999 2.98816 14.5125C3.30072 14.8251 3.72464 15.0007 4.16667 15.0007H9.16667M9.16667 15.0007L6.66667 12.5007M9.16667 15.0007L6.66667 17.5007",
    stroke: "#5A638C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_773_2361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceIcon);
export default __webpack_public_path__ + "static/media/replaceIcon.31bf7a2c.svg";
export { ForwardRef as ReactComponent };